import React, { useEffect, useState } from 'react';
import { Menu, X, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import MagneticButton from './MagneticButton';

const navLinks = [
  { label: 'Intro',       href: '#home',       index: '01' },
  { label: 'Capabilities',href: '#services',   index: '02' },
  { label: 'Studio',      href: '#about',      index: '03' },
  { label: 'Process',     href: '#process',    index: '04' },
  { label: 'Stack',       href: '#technologies',index: '05' },
  { label: 'Contact',     href: '#contact',    index: '06' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 30);
      const h = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(h > 0 ? (window.scrollY / h) * 100 : 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${
          scrolled ? 'bg-black/60 backdrop-blur-xl border-b border-white/5' : 'bg-transparent'
        }`}
      >
        <nav className="max-w-[1400px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
          <a href="#home" className="group flex items-center gap-3" data-cursor="hover">
            <div className="relative w-2 h-2 rounded-full bg-cyan-400 animate-pulseGlow" />
            <span className="text-sm tracking-[0.3em] uppercase font-medium text-white/90">
              OZZLABS
            </span>
            <span className="font-mono text-[10px] text-white/40">— STUDIO / 2025</span>
          </a>

          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-cursor="hover"
                className="group flex items-center gap-2 text-[12px] uppercase tracking-[0.22em] text-white/55 hover:text-white transition-colors duration-500"
              >
                <span className="font-mono text-[10px] text-white/30 group-hover:text-cyan-400 transition-colors">{link.index}</span>
                <span>{link.label}</span>
              </a>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <Link
              to="/paybybity"
              data-cursor="hover"
              className="hidden md:inline-flex items-center gap-2 h-11 px-5 rounded-full text-[12px] uppercase tracking-[0.2em] text-cyan-300 hover:text-white border border-cyan-400/30 hover:border-cyan-400/70 transition-colors duration-500"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-cyan-400 animate-pulseGlow" />
              Pay
            </Link>

            <MagneticButton strength={0.25}>
              <a href="#contact" data-cursor="hover" className="hidden sm:inline-flex items-center gap-2 h-11 pl-5 pr-2 rounded-full btn-ghost text-[12px] uppercase tracking-[0.2em] text-white">
                Begin
                <span className="w-8 h-8 rounded-full bg-white text-black flex items-center justify-center">
                  <ArrowUpRight className="w-4 h-4" />
                </span>
              </a>
            </MagneticButton>

            <button
              className="lg:hidden w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-white"
              onClick={() => setOpen(!open)}
              aria-label="Toggle menu"
              data-cursor="hover"
            >
              {open ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
            </button>
          </div>
        </nav>

        {/* Progress bar */}
        <div className="h-px bg-white/5">
          <div
            className="h-px bg-gradient-to-r from-cyan-400 via-sky-400 to-cyan-400 transition-[width] duration-150"
            style={{ width: `${progress}%` }}
          />
        </div>
      </header>

      {open && (
        <div className="fixed inset-x-0 top-20 z-40 lg:hidden glass-strong border-b border-white/5">
          <div className="px-6 py-4 flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between px-4 py-3 text-sm text-white/80 hover:text-white hover:bg-white/5 rounded-lg transition"
              >
                <span className="uppercase tracking-[0.22em] text-[11px]">{l.label}</span>
                <span className="font-mono text-[10px] text-white/40">{l.index}</span>
              </a>
            ))}
            <Link
              to="/paybybity"
              onClick={() => setOpen(false)}
              className="mt-2 flex items-center justify-between px-4 py-3 text-sm text-cyan-300 border border-cyan-400/30 rounded-lg"
            >
              <span className="uppercase tracking-[0.22em] text-[11px]">Pay</span>
              <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
